import Alpine from 'alpinejs'
import Sortable from 'sortablejs'

import widgetsPlugin from '@clickncode/widgets/plugin.mjs'
import { $u, plugin as uplandPlugin } from '@uplandjs/alpine'
import Deferred from 'p-defer'
import * as dateFns from 'date-fns'
import { $nav } from './lib/$nav.mjs'

window.Alpine = Alpine
window.$u = $u
window.Deferred = Deferred
window.dateFns = dateFns
window.$nav = $nav
window.Sortable = Sortable

Alpine.plugin(uplandPlugin)
Alpine.plugin(widgetsPlugin)
window.addEventListener('DOMContentLoaded', () => {
  Alpine.start()
})
